const CORE_STUDENT_PROJECTS = [
  {
    id: 'ai-resume-helper',
    key: 'aiResume',
    identities: ['senior', 'beginner'],
    goalsMatch: ['internship', 'resume', 'aiTools'],
    title: { zh: 'AI 简历优化助手', en: 'AI Resume Helper' },
    audience: {
      zh: '适合准备实习、想提升简历的学生',
      en: 'For students preparing for internships and resume improvement',
    },
    level: { zh: '进阶', en: 'Advanced' },
    estimatedTime: { zh: '2 周', en: '2 weeks' },
    resumeLine: {
      zh: '实现了一个支持简历上传、AI 分析和优化建议生成的智能简历工具。',
      en: 'Built an intelligent resume tool that supports resume upload, AI analysis, and optimization suggestions.',
    },
    skills: { zh: ['前端', '后端', 'AI API', '文件上传'], en: ['Frontend', 'Backend', 'AI API', 'File upload'] },
    goals: { zh: ['实习', '简历', '作品集', 'AI 工具'], en: ['Internship', 'Resume', 'Portfolio', 'AI tools'] },
    overview: {
      zh: '搭建一个简历分析助手，让学生上传 PDF 或 DOCX 简历，提取核心经历，并把薄弱描述改成更清晰的项目和实习表达。',
      en: 'Build a resume analysis assistant that lets students upload PDF or DOCX resumes, extracts key experience, and turns weak descriptions into clearer project and internship bullet points.',
    },
    coreFeatures: {
      zh: ['上传 PDF / DOCX 简历', '解析简历文本和结构', '生成 AI 优化建议', '展示可复制的简历表达'],
      en: ['Upload PDF or DOCX resumes', 'Extract resume text and structure', 'Generate AI improvement suggestions', 'Show copyable optimized resume lines'],
    },
    techStack: { zh: ['React', 'Node.js', 'Express', 'Multer', 'AI API'], en: ['React', 'Node.js', 'Express', 'Multer', 'AI API'] },
    implementationSteps: {
      zh: ['完成简历上传页面', '实现后端文件解析', '接入 AI 分析请求', '设计结果展示区', '部署上线并准备截图'],
      en: ['Create the resume upload page', 'Implement backend file parsing', 'Connect the AI analysis request', 'Design the result display area', 'Deploy the demo and prepare screenshots'],
    },
    roadmap: {
      zh: [
        { stage: '第 1 阶段：准备与页面搭建', tasks: ['明确目标用户', '完成上传页面', '设计结果卡片'] },
        { stage: '第 2 阶段：后端解析', tasks: ['接入文件上传', '解析 PDF / DOCX', '处理错误情况'] },
        { stage: '第 3 阶段：AI 分析与展示', tasks: ['设计 Prompt', '解析 AI 返回结果', '分区展示优化建议'] },
      ],
      en: [
        { stage: 'Stage 1: Preparation and page setup', tasks: ['Define the target user', 'Build the upload page', 'Design result cards'] },
        { stage: 'Stage 2: Backend parsing', tasks: ['Connect file upload', 'Parse PDF and DOCX files', 'Handle invalid files and errors'] },
        { stage: 'Stage 3: AI analysis and output', tasks: ['Design the prompt', 'Parse the AI response', 'Display suggestions by section'] },
      ],
    },
    interviewQuestions: {
      zh: ['你如何解析 PDF 和 DOCX？', 'AI 返回不是 JSON 时怎么处理？', '上传文件大小和格式怎么限制？'],
      en: ['How do you parse PDF and DOCX files?', 'How do you handle AI output that is not valid JSON?', 'How do you limit uploaded file size and format?'],
    },
  },
  {
    id: 'campus-market',
    key: 'campusMarket',
    identities: ['thesis', 'senior'],
    goalsMatch: ['thesis', 'resume', 'personalProject'],
    title: { zh: '校园二手交易平台', en: 'Campus Second-hand Market' },
    audience: { zh: '适合需要毕设选题或完整 CRUD 项目的学生', en: 'For students who need a thesis topic or a complete CRUD project' },
    level: { zh: '中级', en: 'Intermediate' },
    estimatedTime: { zh: '2 周', en: '2 weeks' },
    resumeLine: {
      zh: '实现了一个支持商品发布、搜索筛选、收藏和交易状态管理的校园二手交易平台。',
      en: 'Built a campus marketplace with item publishing, search, favorites, and transaction status management.',
    },
    skills: { zh: ['React', 'CRUD', '搜索筛选', '数据库设计'], en: ['React', 'CRUD', 'Search', 'Database design'] },
    goals: { zh: ['毕设', '简历', '练手', '演示'], en: ['Thesis', 'Resume', 'Practice', 'Demo'] },
    overview: {
      zh: '创建一个实用的校园二手交易平台，学生可以发布闲置物品、按分类浏览、收藏商品并管理交易状态。',
      en: 'Create a practical campus marketplace where students can publish second-hand goods, browse by category, save items, and manage transaction status.',
    },
    coreFeatures: {
      zh: ['发布二手商品', '按分类搜索和筛选', '收藏感兴趣的商品', '管理商品和交易状态'],
      en: ['Publish second-hand items', 'Search and filter by category', 'Favorite useful listings', 'Manage listing and transaction status'],
    },
    techStack: { zh: ['React', 'Node.js', 'Express', 'MySQL', '云部署'], en: ['React', 'Node.js', 'Express', 'MySQL', 'Cloud deployment'] },
    implementationSteps: {
      zh: ['设计商品和用户数据模型', '搭建列表卡片和详情页', '实现发布和编辑流程', '加入搜索、筛选和收藏', '准备毕设演示脚本'],
      en: ['Design item and user data models', 'Build listing cards and detail page', 'Implement publish and edit flows', 'Add search, filters, and favorites', 'Prepare a thesis demo script'],
    },
    roadmap: {
      zh: [
        { stage: '第 1 阶段：需求和数据模型', tasks: ['明确用户角色', '设计商品字段', '规划页面路由'] },
        { stage: '第 2 阶段：核心交易流程', tasks: ['实现商品列表', '实现发布表单', '完成商品详情页'] },
        { stage: '第 3 阶段：完善和毕设输出', tasks: ['加入搜索和收藏', '撰写需求分析', '准备截图和答辩说明'] },
      ],
      en: [
        { stage: 'Stage 1: Requirements and data model', tasks: ['Clarify user roles', 'Design item fields', 'Plan page routes'] },
        { stage: 'Stage 2: Core marketplace flow', tasks: ['Build item list', 'Build publish form', 'Implement item details'] },
        { stage: 'Stage 3: Polish and thesis output', tasks: ['Add search and favorites', 'Write requirement analysis', 'Prepare screenshots and defense notes'] },
      ],
    },
    interviewQuestions: {
      zh: ['你如何设计商品表？', '如何避免无效商品发布？', '搜索和筛选怎么优化？'],
      en: ['How do you design the item table?', 'How do you prevent invalid item publishing?', 'How do you optimize search and filters?'],
    },
  },
  {
    id: 'study-tracker',
    key: 'studyTracker',
    identities: ['early', 'beginner'],
    goalsMatch: ['personalProject', 'resume', 'aiTools'],
    title: { zh: '学习任务追踪器', en: 'Learning Task Tracker' },
    audience: { zh: '适合大一大二和零基础入门学生', en: 'For freshmen, sophomores, and beginners' },
    level: { zh: '入门', en: 'Beginner' },
    estimatedTime: { zh: '3 天', en: '3 days' },
    resumeLine: {
      zh: '实现了一个支持任务拆解、进度追踪和每日复盘的个人学习规划工具。',
      en: 'Built a personal learning planner with task breakdown, progress tracking, and daily review.',
    },
    skills: { zh: ['React', '状态管理', '本地存储', 'UI 设计'], en: ['React', 'State management', 'Local storage', 'UI design'] },
    goals: { zh: ['练手', '个人项目', '作品集', '学习'], en: ['Practice', 'Personal project', 'Portfolio', 'Study'] },
    overview: {
      zh: '搭建一个轻量学习追踪工具，帮助学生把目标拆成任务、记录每日进度，并复盘完成情况。',
      en: 'Build a lightweight learning tracker that helps students break a goal into tasks, track daily progress, and review what they completed.',
    },
    coreFeatures: {
      zh: ['创建学习目标', '拆解目标任务', '追踪完成状态', '展示每日复盘摘要'],
      en: ['Create learning goals', 'Break goals into tasks', 'Track completion status', 'Show daily review summaries'],
    },
    techStack: { zh: ['React', 'LocalStorage', 'CSS Grid', 'Vite'], en: ['React', 'LocalStorage', 'CSS Grid', 'Vite'] },
    implementationSteps: {
      zh: ['搭建任务列表 UI', '加入创建和编辑状态', '用 localStorage 持久化任务', '加入进度统计', '整理成作品集演示'],
      en: ['Build the task list UI', 'Add create and edit states', 'Persist tasks in localStorage', 'Add progress statistics', 'Package the project as a portfolio demo'],
    },
    roadmap: {
      zh: [
        { stage: '第 1 阶段：基础界面', tasks: ['搭建页面布局', '添加任务卡片', '补齐空状态和完成状态'] },
        { stage: '第 2 阶段：交互和存储', tasks: ['添加任务创建', '切换任务完成状态', '保存本地数据'] },
        { stage: '第 3 阶段：作品集输出', tasks: ['加入进度摘要', '记录项目截图', '撰写简历描述'] },
      ],
      en: [
        { stage: 'Stage 1: Basic UI', tasks: ['Create the layout', 'Add task cards', 'Add empty and completed states'] },
        { stage: 'Stage 2: Interaction and storage', tasks: ['Add task creation', 'Toggle task completion', 'Save data locally'] },
        { stage: 'Stage 3: Portfolio output', tasks: ['Add progress summary', 'Record screenshots', 'Write resume description'] },
      ],
    },
    interviewQuestions: {
      zh: ['为什么选择 localStorage？', '如何避免重复任务？', '以后如何同步到后端？'],
      en: ['Why did you choose localStorage?', 'How do you avoid duplicate tasks?', 'How would you sync this data to a backend later?'],
    },
  },
  {
    id: 'ai-notes-organizer',
    key: 'aiNotes',
    identities: ['early', 'beginner', 'sideIncome'],
    goalsMatch: ['aiTools', 'personalProject', 'competition'],
    title: { zh: 'AI 学习资料整理器', en: 'AI Study Material Organizer' },
    audience: { zh: '适合学习 AI 工具和提升学习效率的学生', en: 'For AI tool learning and study efficiency' },
    level: { zh: '中级', en: 'Intermediate' },
    estimatedTime: { zh: '1 周', en: '1 week' },
    resumeLine: {
      zh: '实现了一个支持资料总结、重点提取和复习卡片生成的 AI 学习整理工具。',
      en: 'Built an AI study organizer that supports document summaries, key point extraction, and review card generation.',
    },
    skills: { zh: ['文件解析', '内容总结', '知识卡片', 'AI 工作流'], en: ['File parsing', 'Summarization', 'Knowledge cards', 'AI workflow'] },
    goals: { zh: ['AI 工具', '学习', '作品集', '竞赛'], en: ['AI tools', 'Study', 'Portfolio', 'Competition'] },
    overview: {
      zh: '把学习资料转成摘要、重点和复习卡片，帮助学生更快完成课程复盘和知识整理。',
      en: 'Create a study assistant that turns uploaded study material into summaries, key points, and review cards for repeated learning.',
    },
    coreFeatures: {
      zh: ['上传学习资料', '生成精简摘要', '提取关键知识点', '创建复习卡片'],
      en: ['Upload study documents', 'Generate concise summaries', 'Extract key points', 'Create review cards'],
    },
    techStack: { zh: ['React', 'AI API', 'Markdown 渲染', 'LocalStorage'], en: ['React', 'AI API', 'Markdown rendering', 'LocalStorage'] },
    implementationSteps: {
      zh: ['设计文档上传或文本输入', '创建摘要结果面板', '接入 AI 总结能力', '生成复习卡片', '加入复制或导出操作'],
      en: ['Design document upload or text input', 'Create summary result panels', 'Connect AI summarization', 'Generate review cards', 'Add export or copy actions'],
    },
    roadmap: {
      zh: [
        { stage: '第 1 阶段：学习流程设计', tasks: ['选择一份真实课程资料', '定义摘要分区', '设计复习卡片格式'] },
        { stage: '第 2 阶段：AI 功能实现', tasks: ['搭建输入区域', '调用 AI 总结流程', '渲染关键知识点'] },
        { stage: '第 3 阶段：可用性和演示', tasks: ['加入复制/导出操作', '找同学试用反馈', '录制演示流程'] },
      ],
      en: [
        { stage: 'Stage 1: Study workflow design', tasks: ['Choose one real course material', 'Define summary sections', 'Design review card format'] },
        { stage: 'Stage 2: AI feature implementation', tasks: ['Build input area', 'Call AI summary flow', 'Render key points'] },
        { stage: 'Stage 3: Usability and demo', tasks: ['Add copy/export actions', 'Test with classmates', 'Record a demo flow'] },
      ],
    },
    interviewQuestions: {
      zh: ['如何控制摘要质量？', '如何避免 AI 回复过长？', '如何判断复习卡片是否有用？'],
      en: ['How do you control summary quality?', 'How do you prevent overly long AI responses?', 'How do you evaluate whether the review cards are useful?'],
    },
  },
  {
    id: 'github-project-analyzer',
    key: 'githubAnalyzer',
    identities: ['senior', 'sideIncome'],
    goalsMatch: ['internship', 'resume', 'personalProject', 'sideIncome'],
    title: { zh: 'GitHub 项目分析器', en: 'GitHub Project Analyzer' },
    audience: { zh: '适合计算机学生和求职作品集', en: 'For CS students and job-search portfolios' },
    level: { zh: '挑战', en: 'Challenge' },
    estimatedTime: { zh: '2 周', en: '2 weeks' },
    resumeLine: {
      zh: '实现了一个可自动评估项目质量、技术栈和简历价值的 GitHub 仓库分析工具。',
      en: 'Implemented a GitHub repository analysis tool that evaluates project quality, tech stack, and resume value automatically.',
    },
    skills: { zh: ['GitHub API', 'AI 分析', '数据展示', '报告生成'], en: ['GitHub API', 'AI analysis', 'Data display', 'Report generation'] },
    goals: { zh: ['实习', '作品集', '简历', '接单演示'], en: ['Internship', 'Portfolio', 'Resume', 'Freelance demo'] },
    overview: {
      zh: '读取公开仓库信息，总结项目质量，并帮助学生把项目价值转化为简历和面试表达。',
      en: 'Build an analyzer that reads public repository information, summarizes project quality, and helps students explain project value in resumes and interviews.',
    },
    coreFeatures: {
      zh: ['输入 GitHub 仓库', '读取 star、issue、语言和活跃度', '生成 AI 项目报告', '总结简历和面试价值'],
      en: ['Input a GitHub repository', 'Read stars, issues, language, and activity', 'Generate an AI project report', 'Summarize resume and interview value'],
    },
    techStack: { zh: ['React', 'GitHub API', 'AI API', '图表', '报告 UI'], en: ['React', 'GitHub API', 'AI API', 'Charts', 'Report UI'] },
    implementationSteps: {
      zh: ['创建仓库输入和校验', '拉取 GitHub 仓库元数据', '设计分析评分卡片', '生成 AI 解读', '加入可分享报告输出'],
      en: ['Create repository input and validation', 'Fetch GitHub repository metadata', 'Design analysis score cards', 'Generate AI explanation', 'Add shareable report output'],
    },
    roadmap: {
      zh: [
        { stage: '第 1 阶段：GitHub 数据基础', tasks: ['校验仓库地址', '获取仓库元数据', '展示基础指标'] },
        { stage: '第 2 阶段：分析报告', tasks: ['设计分析维度', '接入 AI 解读', '渲染报告分区'] },
        { stage: '第 3 阶段：简历和分享', tasks: ['生成简历描述', '准备面试问题', '加入分享或导出流程'] },
      ],
      en: [
        { stage: 'Stage 1: GitHub data foundation', tasks: ['Validate repository URL', 'Fetch repository metadata', 'Display basic stats'] },
        { stage: 'Stage 2: Analysis report', tasks: ['Design analysis dimensions', 'Connect AI explanation', 'Render report sections'] },
        { stage: 'Stage 3: Resume and sharing', tasks: ['Generate resume line', 'Prepare interview questions', 'Add share or export flow'] },
      ],
    },
    interviewQuestions: {
      zh: ['如何处理 GitHub API 限流？', '项目质量维度怎么确定？', '如何让 AI 分析更可信？'],
      en: ['How do you handle GitHub API rate limits?', 'How do you decide project quality dimensions?', 'How do you make AI analysis trustworthy?'],
    },
  },
]

export const STUDENT_MAJOR_GROUPS = [
  { key: 'computer', zh: '计算机 / 软件 / 人工智能', en: 'Computer Science / Software / AI' },
  { key: 'ecommerce', zh: '电商 / 市场营销 / 新媒体', en: 'E-commerce / Marketing / New Media' },
  { key: 'design', zh: '设计 / 视觉 / 数字媒体', en: 'Design / Visual / Digital Media' },
  { key: 'business', zh: '经管 / 财会 / 金融', en: 'Business / Accounting / Finance' },
  { key: 'language', zh: '外语 / 翻译 / 文科', en: 'Languages / Translation / Humanities' },
  { key: 'education', zh: '教育 / 师范', en: 'Education / Teaching' },
  { key: 'engineering', zh: '电子 / 机械 / 自动化', en: 'Engineering / Electronics / Automation' },
  { key: 'medical', zh: '医学 / 护理 / 健康管理', en: 'Medical / Nursing / Health' },
  { key: 'general', zh: '暂时不确定 / 通用方向', en: 'Not sure yet / General' },
]

export const STUDENT_GRADES = [
  { key: 'freshman', zh: '大一', en: 'Freshman' },
  { key: 'sophomore', zh: '大二', en: 'Sophomore' },
  { key: 'junior', zh: '大三', en: 'Junior' },
  { key: 'senior', zh: '大四', en: 'Senior' },
  { key: 'graduate', zh: '毕业/求职中', en: 'Graduating / Job hunting' },
  { key: 'zero', zh: '零基础/转专业', en: 'Beginner / Switching major' },
]

export const STUDENT_PROFILE_GOALS = [
  { key: 'internship', zh: '找实习', en: 'Find an internship' },
  { key: 'resume', zh: '提升简历', en: 'Improve resume' },
  { key: 'graduation', zh: '做毕设/课程设计', en: 'Graduation/course project' },
  { key: 'competition', zh: '参加比赛', en: 'Join competitions' },
  { key: 'portfolio', zh: '做作品集', en: 'Build a portfolio' },
  { key: 'money', zh: '副业赚钱', en: 'Side income' },
  { key: 'aiTools', zh: '学 AI 工具', en: 'Learn AI tools' },
  { key: 'exam', zh: '考研/考试辅助', en: 'Exam support' },
]

export const STUDENT_PROFILE_KEY = 'student_profile'

function localizedProjectTitle(zh, en) {
  return { zh, en }
}

function makeStudentProject({
  id,
  majorGroups,
  goalKeys,
  title,
  titleEn,
  audience,
  audienceEn,
  skills,
  skillsEn,
  searchQuery,
  level = { zh: '入门到中级', en: 'Beginner to intermediate' },
  estimatedTime = { zh: '1-2 周', en: '1-2 weeks' },
}) {
  const safeSkills = skills || ['调研', '整理', '展示']
  const safeSkillsEn = skillsEn || ['Research', 'Organization', 'Presentation']
  return {
    id,
    majorGroups,
    goalKeys,
    identities: ['early', 'senior', 'beginner'],
    goalsMatch: goalKeys,
    title: localizedProjectTitle(title, titleEn),
    audience: localizedProjectTitle(audience, audienceEn),
    level,
    estimatedTime,
    resumeLine: {
      zh: `完成了「${title}」，沉淀了调研、执行、复盘和可展示成果。`,
      en: `Completed "${titleEn}" with research, execution, review, and presentable outcomes.`,
    },
    skills: { zh: safeSkills, en: safeSkillsEn },
    goals: {
      zh: goalKeys.map((goal) => STUDENT_GOAL_LABELS.zh[goal] || goal),
      en: goalKeys.map((goal) => STUDENT_GOAL_LABELS.en[goal] || goal),
    },
    github: {
      searchUrl: `https://github.com/search?q=${encodeURIComponent(searchQuery || titleEn)}&type=repositories`,
      note: {
        zh: '可参考 GitHub 上同类开源项目或模板的结构，不需要照搬代码。',
        en: 'Use similar GitHub projects or templates for structure ideas without copying code directly.',
      },
    },
    overview: {
      zh: `围绕「${title}」完成一个能展示专业能力的小作品，重点是用真实场景、清晰过程和可复盘成果证明能力。`,
      en: `Build a small portfolio-ready project around "${titleEn}" with a real scenario, clear process, and reviewable output.`,
    },
    coreFeatures: {
      zh: ['明确使用场景和目标用户', '整理数据、素材或流程', '形成可展示页面/表格/报告', '输出复盘和简历表达'],
      en: ['Define scenario and target users', 'Organize data, assets, or workflow', 'Create a presentable page, sheet, or report', 'Write a review and resume bullet'],
    },
    techStack: {
      zh: ['Excel/表格', 'AI 工具', '可视化/原型工具', '文档报告'],
      en: ['Spreadsheets', 'AI tools', 'Visualization/prototyping tools', 'Report writing'],
    },
    implementationSteps: {
      zh: ['选择一个真实场景', '收集 20-50 条样本或素材', '完成分析/设计/整理流程', '做成可展示成果', '写出简历描述和复盘'],
      en: ['Choose a real scenario', 'Collect 20-50 samples or assets', 'Finish the analysis/design/organization workflow', 'Package a presentable result', 'Write resume bullets and a review'],
    },
    roadmap: {
      zh: [
        { stage: '第 1 阶段：选题和资料准备', tasks: ['明确目标', '收集样本', '确定展示形式'] },
        { stage: '第 2 阶段：完成核心成果', tasks: ['整理素材', '完成分析或设计', '补齐截图和说明'] },
        { stage: '第 3 阶段：输出作品集', tasks: ['写复盘', '生成简历表达', '准备 2 分钟介绍'] },
      ],
      en: [
        { stage: 'Stage 1: Topic and materials', tasks: ['Clarify the goal', 'Collect samples', 'Choose the output format'] },
        { stage: 'Stage 2: Core result', tasks: ['Organize assets', 'Finish analysis or design', 'Add screenshots and notes'] },
        { stage: 'Stage 3: Portfolio output', tasks: ['Write a review', 'Create resume bullets', 'Prepare a 2-minute pitch'] },
      ],
    },
    interviewQuestions: {
      zh: ['你为什么选择这个场景？', '你如何验证成果有用？', '如果继续迭代，你会先改哪里？'],
      en: ['Why did you choose this scenario?', 'How did you validate the output?', 'What would you improve first?'],
    },
  }
}

const STUDENT_GOAL_LABELS = {
  zh: {
    internship: '找实习',
    resume: '提升简历',
    graduation: '毕设/课程设计',
    competition: '参加比赛',
    portfolio: '做作品集',
    money: '副业赚钱',
    aiTools: '学 AI 工具',
    exam: '考研/考试辅助',
  },
  en: {
    internship: 'Internship',
    resume: 'Resume',
    graduation: 'Graduation project',
    competition: 'Competition',
    portfolio: 'Portfolio',
    money: 'Side income',
    aiTools: 'AI tools',
    exam: 'Exam prep',
  },
}

const ADDITIONAL_STUDENT_PROJECTS = [
  makeStudentProject({ id: 'xiaohongshu-topic-analysis', majorGroups: ['ecommerce', 'general'], goalKeys: ['portfolio', 'money', 'aiTools'], title: '小红书/抖音选题分析表', titleEn: 'Xiaohongshu / TikTok Topic Analysis Sheet', audience: '适合电商、营销和新媒体学生', audienceEn: 'For e-commerce, marketing, and new media students', skills: ['选题分析', '内容运营', '数据复盘'], skillsEn: ['Topic analysis', 'Content operations', 'Data review'], searchQuery: 'social media content calendar analytics' }),
  makeStudentProject({ id: 'campus-store-dashboard', majorGroups: ['ecommerce', 'business'], goalKeys: ['resume', 'portfolio'], title: '校园店铺数据看板', titleEn: 'Campus Store Data Dashboard', audience: '适合想展示数据分析和运营能力的学生', audienceEn: 'For students showing analytics and operations skills', skills: ['销售分析', '看板', '运营指标'], skillsEn: ['Sales analysis', 'Dashboard', 'Operations metrics'], searchQuery: 'sales dashboard spreadsheet retail analytics' }),
  makeStudentProject({ id: 'ai-copywriting-campaign-log', majorGroups: ['ecommerce', 'language', 'general'], goalKeys: ['aiTools', 'money', 'portfolio'], title: 'AI 文案生成与投放记录工具', titleEn: 'AI Copywriting and Campaign Log', audience: '适合营销、新媒体和文案方向学生', audienceEn: 'For marketing, new media, and copywriting students', skills: ['AI 文案', '投放记录', 'A/B 测试'], skillsEn: ['AI copywriting', 'Campaign tracking', 'A/B testing'], searchQuery: 'ai copywriting campaign tracker' }),
  makeStudentProject({ id: 'product-review-sentiment', majorGroups: ['ecommerce', 'business', 'computer'], goalKeys: ['resume', 'portfolio', 'graduation'], title: '商品评论情感分析工具', titleEn: 'Product Review Sentiment Analyzer', audience: '适合电商、经管和数据方向学生', audienceEn: 'For e-commerce, business, and data students', skills: ['评论分析', '情感分类', '数据可视化'], skillsEn: ['Review analysis', 'Sentiment classification', 'Data visualization'], searchQuery: 'product review sentiment analysis dashboard' }),
  makeStudentProject({ id: 'personal-brand-calendar', majorGroups: ['ecommerce', 'language', 'design'], goalKeys: ['portfolio', 'money'], title: '个人品牌内容日历', titleEn: 'Personal Brand Content Calendar', audience: '适合想沉淀新媒体作品集的学生', audienceEn: 'For students building a new media portfolio', skills: ['内容策划', '日历管理', '复盘'], skillsEn: ['Content planning', 'Calendar management', 'Review'], searchQuery: 'content calendar planner open source' }),

  makeStudentProject({ id: 'portfolio-website', majorGroups: ['design', 'computer', 'general'], goalKeys: ['portfolio', 'resume', 'internship'], title: '个人作品集网站', titleEn: 'Personal Portfolio Website', audience: '适合设计、前端和通用求职作品集', audienceEn: 'For design, frontend, and general job-search portfolios', skills: ['作品集', '视觉呈现', '个人品牌'], skillsEn: ['Portfolio', 'Visual presentation', 'Personal branding'], searchQuery: 'portfolio website template' }),
  makeStudentProject({ id: 'ai-poster-workflow', majorGroups: ['design', 'ecommerce'], goalKeys: ['aiTools', 'portfolio'], title: 'AI 海报生成流程整理', titleEn: 'AI Poster Generation Workflow', audience: '适合视觉设计和新媒体学生', audienceEn: 'For visual design and new media students', skills: ['AI 绘图', '视觉规范', '流程整理'], skillsEn: ['AI image generation', 'Visual guidelines', 'Workflow'], searchQuery: 'ai poster generator workflow' }),
  makeStudentProject({ id: 'campus-visual-identity', majorGroups: ['design', 'education'], goalKeys: ['portfolio', 'competition'], title: '校园活动视觉识别方案', titleEn: 'Campus Event Visual Identity System', audience: '适合视觉、数字媒体和活动策划方向', audienceEn: 'For visual, digital media, and event planning students', skills: ['VI 设计', '活动物料', '设计说明'], skillsEn: ['VI design', 'Event assets', 'Design rationale'], searchQuery: 'visual identity guidelines template' }),
  makeStudentProject({ id: 'ui-component-redesign', majorGroups: ['design', 'computer'], goalKeys: ['portfolio', 'internship'], title: 'UI 组件库临摹与改版作品集', titleEn: 'UI Component Library Redesign Portfolio', audience: '适合 UI/UX 和前端入门学生', audienceEn: 'For UI/UX and frontend beginners', skills: ['UI 组件', '交互改版', '设计系统'], skillsEn: ['UI components', 'Interaction redesign', 'Design system'], searchQuery: 'ui component library design system' }),
  makeStudentProject({ id: 'digital-human-guide-prototype', majorGroups: ['design', 'education', 'medical'], goalKeys: ['aiTools', 'portfolio', 'competition'], title: '数字人导览页面原型', titleEn: 'Digital Human Guide Page Prototype', audience: '适合数字媒体、教育和健康科普方向', audienceEn: 'For digital media, education, and health communication students', skills: ['原型设计', 'AI 数字人', '场景脚本'], skillsEn: ['Prototype design', 'AI avatar', 'Scenario scripting'], searchQuery: 'digital human guide prototype' }),

  makeStudentProject({ id: 'personal-budget-analysis', majorGroups: ['business', 'general'], goalKeys: ['resume', 'portfolio'], title: '个人记账与预算分析表', titleEn: 'Personal Budget Analysis Sheet', audience: '适合经管、财会和通用数据作品', audienceEn: 'For business, accounting, and general data portfolios', skills: ['预算分析', '财务记录', '图表'], skillsEn: ['Budget analysis', 'Financial tracking', 'Charts'], searchQuery: 'personal budget dashboard spreadsheet' }),
  makeStudentProject({ id: 'campus-consumption-survey', majorGroups: ['business', 'ecommerce'], goalKeys: ['graduation', 'competition', 'portfolio'], title: '校园消费调研数据分析', titleEn: 'Campus Consumption Survey Analysis', audience: '适合市场调研和经管课程项目', audienceEn: 'For market research and business coursework', skills: ['问卷调研', '数据清洗', '报告'], skillsEn: ['Survey research', 'Data cleaning', 'Report writing'], searchQuery: 'survey analysis dashboard' }),
  makeStudentProject({ id: 'investment-review-sheet', majorGroups: ['business'], goalKeys: ['resume', 'portfolio'], title: '股票/基金模拟投资复盘表', titleEn: 'Stock / Fund Simulation Review Sheet', audience: '适合金融、财会和投资兴趣方向', audienceEn: 'For finance, accounting, and investment interests', skills: ['投资复盘', '风险记录', '收益分析'], skillsEn: ['Investment review', 'Risk tracking', 'Return analysis'], searchQuery: 'investment portfolio tracker spreadsheet' }),
  makeStudentProject({ id: 'business-case-generator', majorGroups: ['business', 'language'], goalKeys: ['aiTools', 'competition'], title: '企业案例分析报告生成器', titleEn: 'Business Case Analysis Report Generator', audience: '适合商赛、案例分析和管理课程', audienceEn: 'For business competitions, cases, and management courses', skills: ['案例分析', 'AI 报告', '商业逻辑'], skillsEn: ['Case analysis', 'AI reports', 'Business logic'], searchQuery: 'business case analysis report generator' }),
  makeStudentProject({ id: 'financial-kpi-dashboard', majorGroups: ['business'], goalKeys: ['resume', 'portfolio'], title: '财务指标可视化看板', titleEn: 'Financial KPI Visualization Dashboard', audience: '适合财会、金融和数据分析方向', audienceEn: 'For accounting, finance, and data analytics students', skills: ['财务指标', '可视化', '经营分析'], skillsEn: ['Financial metrics', 'Visualization', 'Business analysis'], searchQuery: 'financial dashboard open source' }),

  makeStudentProject({ id: 'bilingual-translation-notes', majorGroups: ['language', 'general'], goalKeys: ['aiTools', 'portfolio', 'exam'], title: 'AI 双语翻译对照笔记', titleEn: 'AI Bilingual Translation Notes', audience: '适合外语、翻译和文科学生', audienceEn: 'For language, translation, and humanities students', skills: ['双语对照', '翻译复盘', 'AI 辅助'], skillsEn: ['Bilingual notes', 'Translation review', 'AI assistance'], searchQuery: 'translation memory notes tool' }),
  makeStudentProject({ id: 'spoken-english-plan', majorGroups: ['language', 'education'], goalKeys: ['exam', 'resume'], title: '英语口语练习计划表', titleEn: 'Spoken English Practice Planner', audience: '适合英语表达、考试和面试准备', audienceEn: 'For speaking, exams, and interview prep', skills: ['口语练习', '计划管理', '复盘'], skillsEn: ['Speaking practice', 'Planning', 'Review'], searchQuery: 'language learning tracker' }),
  makeStudentProject({ id: 'reading-card-tool', majorGroups: ['language', 'education', 'general'], goalKeys: ['exam', 'portfolio', 'aiTools'], title: '文献摘要与读书卡片工具', titleEn: 'Literature Summary and Reading Card Tool', audience: '适合文科、教育和考研阅读整理', audienceEn: 'For humanities, education, and exam reading notes', skills: ['文献摘要', '读书卡片', '知识管理'], skillsEn: ['Literature summary', 'Reading cards', 'Knowledge management'], searchQuery: 'reading notes knowledge management' }),
  makeStudentProject({ id: 'english-resume-template', majorGroups: ['language', 'business', 'general'], goalKeys: ['internship', 'resume'], title: '留学/求职英文简历优化模板', titleEn: 'English Resume Optimization Template', audience: '适合留学、外企和英文求职准备', audienceEn: 'For study abroad, multinational firms, and English job search', skills: ['英文简历', '表达优化', '模板设计'], skillsEn: ['English resume', 'Wording polish', 'Template design'], searchQuery: 'english resume template builder' }),
  makeStudentProject({ id: 'wechat-content-planner', majorGroups: ['language', 'ecommerce'], goalKeys: ['portfolio', 'money'], title: '公众号选题与内容策划表', titleEn: 'WeChat Content Topic Planner', audience: '适合文案、新媒体和内容运营方向', audienceEn: 'For copywriting, new media, and content operations', skills: ['内容策划', '标题优化', '发布复盘'], skillsEn: ['Content planning', 'Headline optimization', 'Publishing review'], searchQuery: 'content planner editorial calendar' }),

  makeStudentProject({ id: 'lesson-plan-assistant', majorGroups: ['education'], goalKeys: ['aiTools', 'portfolio', 'internship'], title: '课程教案生成助手', titleEn: 'Lesson Plan Assistant', audience: '适合教育、师范和教培实习准备', audienceEn: 'For education, teaching, and tutoring internships', skills: ['教案设计', 'AI 辅助', '课堂目标'], skillsEn: ['Lesson design', 'AI assistance', 'Teaching goals'], searchQuery: 'lesson plan generator' }),
  makeStudentProject({ id: 'homework-feedback-library', majorGroups: ['education'], goalKeys: ['resume', 'portfolio'], title: '学生作业反馈模板库', titleEn: 'Homework Feedback Template Library', audience: '适合师范生和助教岗位准备', audienceEn: 'For teaching students and TA roles', skills: ['反馈模板', '评价标准', '教学沟通'], skillsEn: ['Feedback templates', 'Rubrics', 'Teaching communication'], searchQuery: 'teacher feedback template library' }),
  makeStudentProject({ id: 'class-learning-stats', majorGroups: ['education', 'business'], goalKeys: ['portfolio', 'graduation'], title: '班级学习情况统计表', titleEn: 'Class Learning Statistics Sheet', audience: '适合教育数据和班级管理场景', audienceEn: 'For education data and class management scenarios', skills: ['学习统计', '表格分析', '班级管理'], skillsEn: ['Learning analytics', 'Spreadsheet analysis', 'Class management'], searchQuery: 'student performance dashboard' }),
  makeStudentProject({ id: 'micro-course-script-tool', majorGroups: ['education', 'design'], goalKeys: ['portfolio', 'competition'], title: '微课脚本与课件整理工具', titleEn: 'Micro-course Script and Slides Organizer', audience: '适合微课比赛和教学作品集', audienceEn: 'For micro-course contests and teaching portfolios', skills: ['微课脚本', '课件整理', '教学设计'], skillsEn: ['Micro-course script', 'Slides organization', 'Instructional design'], searchQuery: 'course script template slides' }),
  makeStudentProject({ id: 'personalized-learning-plan', majorGroups: ['education', 'computer', 'general'], goalKeys: ['aiTools', 'competition'], title: 'AI 个性化学习计划生成器', titleEn: 'AI Personalized Learning Plan Generator', audience: '适合教育科技和 AI 应用方向', audienceEn: 'For edtech and AI application students', skills: ['学习路径', 'AI 生成', '个性化推荐'], skillsEn: ['Learning path', 'AI generation', 'Personalization'], searchQuery: 'personalized learning plan generator' }),

  makeStudentProject({ id: 'mcu-smart-car', majorGroups: ['engineering'], goalKeys: ['competition', 'graduation', 'resume'], title: '单片机智能小车项目', titleEn: 'MCU Smart Car Project', audience: '适合电子、自动化和工程实践', audienceEn: 'For electronics, automation, and engineering practice', skills: ['单片机', '传感器', '控制逻辑'], skillsEn: ['MCU', 'Sensors', 'Control logic'], searchQuery: 'arduino smart car project' }),
  makeStudentProject({ id: 'sensor-dashboard', majorGroups: ['engineering', 'computer'], goalKeys: ['graduation', 'portfolio'], title: '传感器数据采集看板', titleEn: 'Sensor Data Collection Dashboard', audience: '适合物联网、自动化和数据展示', audienceEn: 'For IoT, automation, and data display', skills: ['传感器', '数据采集', '看板'], skillsEn: ['Sensors', 'Data collection', 'Dashboard'], searchQuery: 'iot sensor dashboard open source' }),
  makeStudentProject({ id: 'equipment-maintenance-log', majorGroups: ['engineering', 'business'], goalKeys: ['resume', 'portfolio'], title: '设备维护记录系统', titleEn: 'Equipment Maintenance Log System', audience: '适合工程管理和设备维护场景', audienceEn: 'For engineering management and maintenance scenarios', skills: ['维护记录', '流程管理', '统计'], skillsEn: ['Maintenance logs', 'Workflow management', 'Statistics'], searchQuery: 'equipment maintenance management system' }),
  makeStudentProject({ id: 'mechanical-design-doc', majorGroups: ['engineering'], goalKeys: ['graduation', 'resume'], title: '机械结构设计说明文档模板', titleEn: 'Mechanical Structure Design Documentation Template', audience: '适合机械课程设计和毕设准备', audienceEn: 'For mechanical coursework and graduation projects', skills: ['结构说明', '参数记录', '设计复盘'], skillsEn: ['Structure explanation', 'Parameter tracking', 'Design review'], searchQuery: 'mechanical design documentation template' }),
  makeStudentProject({ id: 'iot-environment-monitor', majorGroups: ['engineering', 'medical'], goalKeys: ['competition', 'graduation'], title: '物联网环境监测项目', titleEn: 'IoT Environment Monitoring Project', audience: '适合工程、健康管理和创新比赛', audienceEn: 'For engineering, health management, and innovation contests', skills: ['物联网', '环境监测', '数据展示'], skillsEn: ['IoT', 'Environment monitoring', 'Data display'], searchQuery: 'iot environmental monitoring system' }),

  makeStudentProject({ id: 'health-habit-tracker', majorGroups: ['medical', 'general'], goalKeys: ['portfolio', 'aiTools'], title: '健康打卡与习惯追踪表', titleEn: 'Health Check-in and Habit Tracker', audience: '适合健康管理、护理和通用自我管理', audienceEn: 'For health management, nursing, and general self-management', skills: ['健康打卡', '习惯追踪', '可视化'], skillsEn: ['Health check-in', 'Habit tracking', 'Visualization'], searchQuery: 'health habit tracker app' }),
  makeStudentProject({ id: 'nursing-review-cards', majorGroups: ['medical', 'education'], goalKeys: ['exam', 'resume'], title: '护理知识复习卡片', titleEn: 'Nursing Knowledge Review Cards', audience: '适合护理复习和知识整理', audienceEn: 'For nursing review and knowledge organization', skills: ['复习卡片', '知识分类', '考试辅助'], skillsEn: ['Review cards', 'Knowledge categorization', 'Exam prep'], searchQuery: 'nursing flashcards app' }),
  makeStudentProject({ id: 'chronic-disease-content', majorGroups: ['medical', 'language'], goalKeys: ['portfolio', 'competition'], title: '慢病管理科普内容库', titleEn: 'Chronic Disease Education Content Library', audience: '适合健康科普和医学传播方向', audienceEn: 'For health education and medical communication', skills: ['健康科普', '内容库', '用户教育'], skillsEn: ['Health education', 'Content library', 'User education'], searchQuery: 'health education content library' }),
  makeStudentProject({ id: 'medical-literature-notes', majorGroups: ['medical', 'language'], goalKeys: ['exam', 'aiTools', 'graduation'], title: '医学文献摘要笔记', titleEn: 'Medical Literature Summary Notes', audience: '适合医学文献阅读和科研入门', audienceEn: 'For medical literature reading and research beginners', skills: ['文献摘要', '医学术语', 'AI 辅助'], skillsEn: ['Literature summary', 'Medical terms', 'AI assistance'], searchQuery: 'medical literature summary notes' }),
  makeStudentProject({ id: 'campus-health-survey', majorGroups: ['medical', 'business'], goalKeys: ['competition', 'graduation'], title: '校园健康问卷分析', titleEn: 'Campus Health Survey Analysis', audience: '适合健康管理、护理和公共卫生调研', audienceEn: 'For health management, nursing, and public health research', skills: ['问卷分析', '健康数据', '报告'], skillsEn: ['Survey analysis', 'Health data', 'Report writing'], searchQuery: 'health survey analysis dashboard' }),

  makeStudentProject({ id: 'competition-plan-generator', majorGroups: ['general', 'business', 'education'], goalKeys: ['competition', 'aiTools'], title: '比赛项目计划书生成器', titleEn: 'Competition Project Proposal Generator', audience: '适合还没有明确专业项目但想参赛的学生', audienceEn: 'For students who want to compete before choosing a project direction', skills: ['项目计划书', 'AI 生成', '路演结构'], skillsEn: ['Project proposal', 'AI generation', 'Pitch structure'], searchQuery: 'project proposal generator template' }),
  makeStudentProject({ id: 'study-flashcard-organizer', majorGroups: ['general', 'language', 'education'], goalKeys: ['exam', 'aiTools'], title: '资料整理与复习卡片工具', titleEn: 'Study Material and Flashcard Organizer', audience: '适合考试复习和课程资料整理', audienceEn: 'For exam prep and course material organization', skills: ['资料整理', '复习卡片', '学习计划'], skillsEn: ['Material organization', 'Flashcards', 'Study planning'], searchQuery: 'flashcard study organizer open source' }),
]

const PROJECT_DEFAULTS = {
  'ai-resume-helper': {
    majorGroups: ['computer', 'language', 'business', 'general'],
    goalKeys: ['internship', 'resume', 'portfolio', 'aiTools'],
    github: { searchUrl: 'https://github.com/search?q=ai+resume+builder&type=repositories' },
  },
  'campus-market': {
    majorGroups: ['computer', 'business', 'general'],
    goalKeys: ['graduation', 'resume', 'portfolio'],
    github: { searchUrl: 'https://github.com/search?q=campus+marketplace&type=repositories' },
  },
  'study-tracker': {
    majorGroups: ['computer', 'education', 'general'],
    goalKeys: ['portfolio', 'resume', 'exam'],
    github: { searchUrl: 'https://github.com/search?q=study+task+tracker&type=repositories' },
  },
  'ai-notes-organizer': {
    majorGroups: ['computer', 'education', 'language', 'general'],
    goalKeys: ['aiTools', 'exam', 'portfolio'],
    github: { searchUrl: 'https://github.com/search?q=ai+study+notes+organizer&type=repositories' },
  },
  'github-project-analyzer': {
    majorGroups: ['computer'],
    goalKeys: ['internship', 'resume', 'portfolio'],
    github: { searchUrl: 'https://github.com/search?q=github+repository+analyzer&type=repositories' },
  },
}

const RESOURCE_TYPE_LABELS = {
  report: { zh: '调研/分析报告', en: 'Research / analysis report' },
  portfolio: { zh: '作品集', en: 'Portfolio' },
  spreadsheet: { zh: '表格/数据看板', en: 'Spreadsheet / dashboard' },
  presentation: { zh: '方案/PPT', en: 'Presentation / proposal' },
  research: { zh: '调研成果', en: 'Research output' },
  contentPlan: { zh: '内容策划', en: 'Content plan' },
  prototype: { zh: '原型/设计方案', en: 'Prototype / design plan' },
  teachingPlan: { zh: '教案/教学材料', en: 'Teaching plan' },
}

const RESOURCE_BY_MAJOR = {
  ecommerce: 'contentPlan',
  design: 'portfolio',
  business: 'spreadsheet',
  language: 'report',
  education: 'teachingPlan',
  medical: 'research',
  general: 'portfolio',
}

const TOOLS_BY_RESOURCE = {
  report: { zh: ['飞书文档', 'Excel', 'AI 总结工具'], en: ['Feishu Docs', 'Excel', 'AI summarizer'] },
  portfolio: { zh: ['Canva', 'Figma', '作品集网站'], en: ['Canva', 'Figma', 'Portfolio site'] },
  spreadsheet: { zh: ['Excel', '飞书表格', '数据透视表'], en: ['Excel', 'Feishu Sheets', 'Pivot tables'] },
  presentation: { zh: ['PowerPoint', 'Canva', 'AI 大纲工具'], en: ['PowerPoint', 'Canva', 'AI outline tools'] },
  research: { zh: ['问卷星', 'Excel', '文献笔记'], en: ['Survey tools', 'Excel', 'Literature notes'] },
  contentPlan: { zh: ['飞书表格', 'Excel', 'Canva', 'AI 文案工具'], en: ['Feishu Sheets', 'Excel', 'Canva', 'AI writing tools'] },
  prototype: { zh: ['Figma', '墨刀', 'Canva'], en: ['Figma', 'MockingBot', 'Canva'] },
  teachingPlan: { zh: ['Word', 'PPT', 'AI 教案工具'], en: ['Word', 'PowerPoint', 'AI lesson tools'] },
}

const COMPETITIONS_BY_MAJOR = {
  computer: { zh: ['创新创业大赛', '计算机设计大赛', '服务外包创新创业大赛'], en: ['Innovation competition', 'Computer design contest', 'Service outsourcing contest'] },
  ecommerce: { zh: ['新媒体内容创作比赛', '职业规划大赛', '商业案例分析比赛'], en: ['New media content contest', 'Career planning contest', 'Business case competition'] },
  design: { zh: ['广告艺术大赛 / 大广赛', '校园产品设计比赛', '创新创业训练计划'], en: ['Advertising art competition', 'Product design contest', 'Innovation training program'] },
  business: { zh: ['商业案例分析比赛', '职业规划大赛', '创新创业大赛'], en: ['Business case competition', 'Career planning contest', 'Innovation competition'] },
  language: { zh: ['外研社英语比赛', '新媒体内容创作比赛', '职业规划大赛'], en: ['FLTRP English contests', 'New media content contest', 'Career planning contest'] },
  education: { zh: ['师范生教学技能比赛', '微课比赛', '创新创业训练计划'], en: ['Teaching skills contest', 'Micro-course contest', 'Innovation training program'] },
  engineering: { zh: ['电子设计竞赛', '机械创新设计大赛', '创新创业训练计划'], en: ['Electronic design contest', 'Mechanical innovation contest', 'Innovation training program'] },
  medical: { zh: ['护理技能比赛', '健康科普比赛', '校园创新实践展示'], en: ['Nursing skills contest', 'Health communication contest', 'Campus practice showcase'] },
  general: { zh: ['职业规划大赛', '简历设计比赛', '学院级项目展示'], en: ['Career planning contest', 'Resume design contest', 'Department project showcase'] },
}

function primaryMajor(project) {
  return project.majorGroups?.find((item) => item !== 'general') || 'general'
}

function projectResourceType(project) {
  const major = primaryMajor(project)
  return project.resourceType || RESOURCE_BY_MAJOR[major] || 'portfolio'
}

function isGithubProject(project) {
  return project.type
    ? project.type === 'github'
    : project.majorGroups?.includes('computer') || ['mcu-smart-car', 'sensor-dashboard', 'iot-environment-monitor'].includes(project.id)
}

function normalizeProject(project) {
  const defaults = PROJECT_DEFAULTS[project.id] || {}
  const goalKeys = project.goalKeys || project.goalsMatch || defaults.goalKeys || ['resume', 'portfolio']
  const type = isGithubProject(project) ? 'github' : 'non-code'
  const resourceType = projectResourceType(project)
  const major = primaryMajor(project)
  const github = {
    ...(defaults.github || {}),
    ...(project.github || {}),
    note: project.github?.note || {
      zh: '可参考 GitHub 上同类开源项目的实现思路。',
      en: 'Use similar GitHub open-source projects as implementation references.',
    },
  }

  return {
    ...project,
    majorGroups: project.majorGroups || defaults.majorGroups || ['general'],
    goalKeys,
    goalsMatch: project.goalsMatch || goalKeys,
    type,
    resourceType,
    resourceTypeLabel: project.resourceTypeLabel || RESOURCE_TYPE_LABELS[resourceType],
    finalOutput: project.finalOutput || {
      zh: type === 'github' ? '可运行 demo + 项目截图 + README/说明文档' : `${pickStudentText(RESOURCE_TYPE_LABELS[resourceType], 'zh')} + 过程记录 + 可展示成果`,
      en: type === 'github' ? 'Runnable demo + screenshots + README/documentation' : `${pickStudentText(RESOURCE_TYPE_LABELS[resourceType], 'en')} + process notes + presentable output`,
    },
    materials: project.materials || {
      zh: ['真实场景', '样本数据/素材', '过程截图', '复盘记录'],
      en: ['Real scenario', 'Sample data/assets', 'Process screenshots', 'Review notes'],
    },
    displayMaterials: project.displayMaterials || {
      zh: ['截图', '表格/报告 PDF', 'PPT', '作品集链接'],
      en: ['Screenshots', 'Spreadsheet/report PDF', 'Slides', 'Portfolio link'],
    },
    sevenDayPlan: project.sevenDayPlan || {
      zh: ['Day 1：明确最终产出和目标人群', 'Day 2：收集 20-50 条样本或参考', 'Day 3：完成结构大纲和素材整理', 'Day 4：制作第一版成果', 'Day 5：补齐截图、图表或说明文档', 'Day 6：写出 2-3 条简历 bullet', 'Day 7：整理成可展示版本并复盘'],
      en: ['Day 1: Define final output and audience', 'Day 2: Collect 20-50 samples or references', 'Day 3: Create outline and organize materials', 'Day 4: Build the first version', 'Day 5: Add screenshots, charts, or notes', 'Day 6: Write 2-3 resume bullets', 'Day 7: Package it for presentation and review'],
    },
    resumeBullets: project.resumeBullets || {
      zh: [
        `完成「${pickStudentText(project.title, 'zh')}」，围绕真实场景整理需求、素材和执行流程。`,
        `产出${type === 'github' ? '可运行 demo 和说明文档' : pickStudentText(RESOURCE_TYPE_LABELS[resourceType], 'zh')}，沉淀可展示的过程记录和复盘结论。`,
      ],
      en: [
        `Completed ${pickStudentText(project.title, 'en')} around a real scenario with requirements, materials, and execution steps.`,
        `Delivered ${type === 'github' ? 'a runnable demo and documentation' : pickStudentText(RESOURCE_TYPE_LABELS[resourceType], 'en')} with presentable process notes and review conclusions.`,
      ],
    },
    tools: project.tools || TOOLS_BY_RESOURCE[resourceType] || TOOLS_BY_RESOURCE.portfolio,
    referenceKeywords: project.referenceKeywords || {
      zh: [pickStudentText(project.title, 'zh'), '作品集 模板', '项目复盘'],
      en: [pickStudentText(project.title, 'en'), 'portfolio template', 'project case study'],
    },
    suitableCompetitions: project.suitableCompetitions || COMPETITIONS_BY_MAJOR[major] || COMPETITIONS_BY_MAJOR.general,
    github: type === 'github' ? github : undefined,
  }
}

export const STUDENT_PROJECTS = [...CORE_STUDENT_PROJECTS, ...ADDITIONAL_STUDENT_PROJECTS].map(normalizeProject)

export function pickStudentText(value, language = 'zh') {
  if (value == null) return ''
  if (typeof value === 'string') return value
  if (Array.isArray(value)) return value
  if (typeof value === 'object') {
    return value[language] ?? value.zh ?? value.en ?? ''
  }
  return ''
}

export function pickStudentList(value, language = 'zh') {
  const picked = pickStudentText(value, language)
  return Array.isArray(picked) ? picked : []
}

export function getStudentOptionLabel(options, key, language = 'zh') {
  const match = options.find((item) => item.key === key)
  return match ? match[language === 'en' ? 'en' : 'zh'] : key
}

export function readStoredStudentProfile() {
  if (typeof window === 'undefined') return null
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STUDENT_PROFILE_KEY) || 'null')
    if (!parsed || typeof parsed !== 'object') return null
    const majorGroup = STUDENT_MAJOR_GROUPS.some((item) => item.key === parsed.majorGroup) ? parsed.majorGroup : ''
    const grade = STUDENT_GRADES.some((item) => item.key === parsed.grade) ? parsed.grade : ''
    const goal = STUDENT_PROFILE_GOALS.some((item) => item.key === parsed.goal) ? parsed.goal : ''
    return majorGroup && grade && goal
      ? { majorGroup, grade, goal, targetRole: parsed.targetRole || '', updatedAt: parsed.updatedAt || '' }
      : null
  } catch {
    return null
  }
}

export function saveStoredStudentProfile(profile) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(STUDENT_PROFILE_KEY, JSON.stringify(profile))
}

const RESUME_EXAMPLES_BY_MAJOR = {
  computer: ['GitHub 项目分析器', 'AI 简历优化助手', '校园二手交易系统', '学习任务追踪 App'],
  ecommerce: ['小红书选题分析与内容日历', '校园店铺数据看板', '商品评论情感分析', '品牌竞品分析报告'],
  design: ['个人作品集网站', '校园活动视觉识别方案', 'AI 海报生成流程', 'UI 改版案例'],
  business: ['个人记账与预算分析', '校园消费调研数据分析', '企业案例分析报告', '财务指标可视化看板'],
  language: ['双语翻译对照笔记', '文献摘要与读书卡片', '英文简历优化模板', '公众号内容策划表'],
  education: ['课程教案生成助手', '学生作业反馈模板库', '班级学习情况统计', '微课脚本与课件整理'],
  engineering: ['单片机智能小车项目', '传感器数据采集看板', '设备维护记录系统', '物联网环境监测项目'],
  medical: ['健康打卡与习惯追踪', '护理知识复习卡片', '慢病管理科普内容库', '校园健康问卷分析'],
  general: ['学习任务追踪', '资料整理与复习卡片', '个人作品集', '比赛项目计划书'],
}

const RESUME_EXAMPLES_BY_MAJOR_EN = {
  computer: ['GitHub Project Analyzer', 'AI Resume Helper', 'Campus Second-hand Market', 'Learning Task Tracker App'],
  ecommerce: ['Xiaohongshu Topic Analysis & Content Calendar', 'Campus Store Data Dashboard', 'Product Review Sentiment Analysis', 'Brand Competitor Analysis Report'],
  design: ['Personal Portfolio Website', 'Campus Event Visual Identity System', 'AI Poster Generation Workflow', 'UI Redesign Case Study'],
  business: ['Personal Budget Analysis', 'Campus Consumption Survey Analysis', 'Business Case Analysis Report', 'Financial KPI Dashboard'],
  language: ['Bilingual Translation Notes', 'Literature Summary and Reading Cards', 'English Resume Template', 'WeChat Content Planner'],
  education: ['Lesson Plan Assistant', 'Homework Feedback Template Library', 'Class Learning Statistics', 'Micro-course Script Organizer'],
  engineering: ['MCU Smart Car Project', 'Sensor Data Collection Dashboard', 'Equipment Maintenance Log System', 'IoT Environment Monitoring Project'],
  medical: ['Health Check-in and Habit Tracker', 'Nursing Review Cards', 'Chronic Disease Education Content Library', 'Campus Health Survey Analysis'],
  general: ['Learning Task Tracker', 'Study Material and Flashcard Organizer', 'Personal Portfolio', 'Competition Project Proposal'],
}

export function buildInitialResumeDraft(profile, language = 'zh') {
  const isEnglish = language === 'en'
  const major = profile?.majorGroup || 'general'
  const targetRole = profile?.targetRole || (isEnglish ? 'target internship / entry-level role' : '目标实习/入门岗位')
  const majorLabel = getStudentOptionLabel(STUDENT_MAJOR_GROUPS, major, language)
  const gradeLabel = getStudentOptionLabel(STUDENT_GRADES, profile?.grade || 'junior', language)
  const goalLabel = getStudentOptionLabel(STUDENT_PROFILE_GOALS, profile?.goal || 'internship', language)
  const examples = (isEnglish ? RESUME_EXAMPLES_BY_MAJOR_EN : RESUME_EXAMPLES_BY_MAJOR)[major] || (isEnglish ? RESUME_EXAMPLES_BY_MAJOR_EN.general : RESUME_EXAMPLES_BY_MAJOR.general)

  if (isEnglish) {
    return {
      warning: 'This is a first-draft reference. Replace every example with your real experience and do not invent experience.',
      sections: [
        { title: 'Career Objective', items: [`Target: ${targetRole}`, `Background: ${majorLabel} / ${gradeLabel}`, `Current goal: ${goalLabel}`] },
        { title: 'Personal Strength Summary', items: ['Able to turn coursework, campus practice, or self-learning into structured outputs.', 'Can use AI tools and spreadsheets/docs/prototypes to improve efficiency.', 'Has room to add real metrics, links, screenshots, and role contribution.'] },
        { title: 'Education Wording', items: [`Major direction: ${majorLabel}`, 'Relevant courses: replace with 3-5 real courses related to your target role.', 'Course results: add ranking, assignment, report, or project proof if true.'] },
        { title: 'Skills Module Suggestions', items: ['Tools: write only tools you have actually used.', 'Methods: research, analysis, content planning, prototype design, or project execution.', 'Output: reports, dashboards, portfolios, lesson plans, or demos.'] },
        { title: 'Project / Outcome Examples', items: examples.map((item) => `${item}: describe goal, process, output, and measurable result.`) },
        { title: 'Campus / Competition Experience', items: ['Use STAR: situation, task, action, result.', 'Mention your individual contribution instead of only team name.', 'Attach outcome links or screenshots where possible.'] },
        { title: 'Copy-ready Resume Bullets', items: examples.slice(0, 3).map((item) => `Completed ${item}, organized the workflow and final output, and summarized reusable methods for ${targetRole}.`) },
        { title: 'Information To Add Next', items: ['School, major, graduation year, contact information.', 'Real courses, awards, practice, certificates, and project links.', 'Numbers: sample size, views, completion rate, time saved, accuracy, or user feedback.'] },
        { title: '7-day Resume Plan', items: ['Day 1: choose one target role and collect job requirements.', 'Day 2: list real coursework and campus experiences.', 'Day 3-4: complete one small outcome project.', 'Day 5: write 3 project bullets.', 'Day 6: make the resume one page.', 'Day 7: upload it for AI analysis and rewrite.'] },
      ],
    }
  }

  return {
    warning: '以下是初版参考，请根据你的真实经历修改，不要直接虚构经历。',
    sections: [
      { title: '求职意向', items: [`目标：${targetRole}`, `背景：${majorLabel} / ${gradeLabel}`, `当前目标：${goalLabel}`] },
      { title: '个人优势概述', items: ['能把课程作业、校园实践或自学内容整理成结构化成果。', '能使用 AI 工具、表格、文档或原型工具提升执行效率。', '后续需要补充真实数据、链接、截图和个人贡献。'] },
      { title: '教育背景写法', items: [`专业方向：${majorLabel}`, '相关课程：替换成 3-5 门与目标岗位相关的真实课程。', '课程成果：如有排名、课程报告、课程设计或项目截图，可以补充。'] },
      { title: '技能模块建议', items: ['工具：只写自己真实使用过的工具。', '方法：调研分析、内容策划、原型设计、项目执行、数据整理等。', '产出：报告、看板、作品集、教案、科普内容或可运行 demo。'] },
      { title: '项目/成果经历示例', items: examples.map((item) => `${item}：描述目标、过程、最终产出和可量化结果。`) },
      { title: '校园经历/比赛经历写法', items: ['用 STAR 写法：背景、任务、行动、结果。', '写清个人贡献，不要只写团队名称。', '能附链接、截图、证书或展示页就更好。'] },
      { title: '可直接复制的简历 bullet', items: examples.slice(0, 3).map((item) => `完成「${item}」，梳理执行流程并形成可展示成果，沉淀适用于${targetRole}的项目经验。`) },
      { title: '后续需要补充的信息', items: ['学校、专业、毕业时间、联系方式。', '真实课程、奖项、实践、证书和项目链接。', '数字结果：样本量、阅读量、完成率、节省时间、准确率或反馈人数。'] },
      { title: '7 天完善简历计划', items: ['第 1 天：确定一个目标岗位并收集岗位要求。', '第 2 天：列出真实课程作业和校园经历。', '第 3-4 天：完成一个小型成果项目。', '第 5 天：写出 3 条项目 bullet。', '第 6 天：整理成一页简历。', '第 7 天：上传简历做 AI 分析和改写。'] },
    ],
  }
}

export function getStudentProjectById(projectId) {
  return STUDENT_PROJECTS.find((project) => project.id === projectId)
}

export function getStoredStudentPlanProjects() {
  if (typeof window === 'undefined') {
    return []
  }

  try {
    const parsed = JSON.parse(window.localStorage.getItem('student_plan_projects') || '[]')
    return Array.isArray(parsed)
      ? parsed.filter((item) => item && typeof item.id === 'string')
      : []
  } catch {
    return []
  }
}

export function saveStoredStudentPlanProjects(projects) {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem('student_plan_projects', JSON.stringify(projects))
}

export function buildProjectResumeDraft(project, language = 'zh') {
  const title = pickStudentText(project?.title, language) || '推荐项目'
  const techStack = pickStudentList(project?.techStack, language)
  const skills = pickStudentList(project?.skills, language)
  const bullets = pickStudentList(project?.resumeBullets, language)
  const resumeLine = pickStudentText(project?.resumeLine, language)
  const stack = techStack.length ? techStack : skills

  if (language === 'en') {
    return {
      name: title,
      role: 'Project owner: requirements breakdown, core feature implementation, documentation, and resume-ready output.',
      techStack: stack,
      star: `Situation: built ${title} for a real student/job-search scenario. Task: complete a usable core flow and presentable output. Action: broke down requirements, implemented core features, organized screenshots and notes. Result: produced a portfolio-ready project that can support resume and interview discussion.`,
      resumeText: resumeLine || bullets[0] || `Completed ${title}, implemented the core workflow, and summarized reusable project outcomes for resume presentation.`,
    }
  }

  return {
    name: title,
    role: '项目负责人：负责需求拆解、核心功能实现、文档整理和简历表达沉淀。',
    techStack: stack,
    star: `背景：围绕真实学习/求职场景完成「${title}」。任务：做出可运行或可展示的核心成果。行动：拆解需求，完成核心流程，整理截图、说明文档和复盘记录。结果：形成可写进简历、可用于面试讲述的项目经历。`,
    resumeText: resumeLine || bullets[0] || `完成「${title}」，实现核心流程并沉淀可展示成果，用于简历项目经历和面试讲述。`,
  }
}

export function buildProjectGrowthTasks(project, language = 'zh') {
  const title = pickStudentText(project?.title, language) || '推荐项目'
  const prefix = language === 'en' ? title : `「${title}」`
  return language === 'en'
    ? [
      `Read the README or reference notes for ${prefix}`,
      `Set up the local environment for ${prefix}`,
      `Complete one core feature of ${prefix}`,
      `Write a project summary and resume bullet for ${prefix}`,
    ]
    : [
      `阅读 ${prefix} README 或参考资料`,
      `搭建 ${prefix} 本地环境`,
      `完成 ${prefix} 一个核心功能`,
      `写 ${prefix} 项目总结和简历 bullet`,
    ]
}

export function getStoredStudentProjectTasks() {
  if (typeof window === 'undefined') return []
  try {
    const parsed = JSON.parse(window.localStorage.getItem('student_project_tasks') || '[]')
    return Array.isArray(parsed) ? parsed.filter(Boolean) : []
  } catch {
    return []
  }
}

export function saveStoredStudentProjectTasks(tasks) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem('student_project_tasks', JSON.stringify(tasks))
}

export function getStoredStudentInterviewPack() {
  if (typeof window === 'undefined') return null
  try {
    const parsed = JSON.parse(window.localStorage.getItem('student_interview_pack') || 'null')
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch {
    return null
  }
}

export function saveStoredStudentInterviewPack(pack) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem('student_interview_pack', JSON.stringify(pack))
}

export function getStoredStudentInterviewTasks() {
  if (typeof window === 'undefined') return []
  try {
    const parsed = JSON.parse(window.localStorage.getItem('student_interview_tasks') || '[]')
    return Array.isArray(parsed) ? parsed.filter(Boolean) : []
  } catch {
    return []
  }
}

export function saveStoredStudentInterviewTasks(tasks) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem('student_interview_tasks', JSON.stringify(tasks))
}
